// extracted by mini-css-extract-plugin
module.exports = {"comingSoonContainer":"ComingSoon_comingSoonContainer__2wsWj","logo":"ComingSoon_logo__15Wbv"};